export enum FaelligkeitsSchnellauswahl {
  DREI_TAGE = 'dreiTage',
  SIEBEN_TAGE = 'siebenTage',
  ACHT_PLUS_TAGE = 'achtPlusTage',
}
